import { useState, useRef } from 'react';

export const useTextInputState = (
  onFilterChanged: (value: string) => void,
  onClear?: () => void,
  defaultValue?: string
) => {
  const [showClearButton, setShowClearButton] = useState(Boolean(defaultValue));
  const inputRef = useRef<HTMLInputElement>(null);

  const handleValueChange = (value: string) => {
    onFilterChanged(value);
    setShowClearButton(value.length > 0);
  };

  const onClearClick = onClear
    ? (e: React.MouseEvent<HTMLDivElement>) => {
        if (inputRef.current) {
          e.stopPropagation();
          inputRef.current.value = '';
          inputRef.current.focus();
          onFilterChanged('');
          setShowClearButton(false);
        }
        onClear();
      }
    : undefined;

  const hasClearButton = Boolean(onClear && showClearButton);

  return { handleValueChange, inputRef, onClearClick, hasClearButton };
};
